import axios from "axios";
import { getDeviceInfo } from "../../helper/helper";


export const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
    "ngrok-skip-browser-warning": "true", //69240
    "x-platform": "web",
    "x-device-name": getDeviceInfo(),
  }
});


export const getLoggedInUserInfo = () => {
  const user = localStorage.getItem("user");
  return user ? JSON.parse(user) : null;
};

export const signupApi = (data) => {
  return API.post("/auth/signup", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const sendOtpApi = (data) => {
  return API.post("/auth/send-otp", data);
};

export const loginApi = (data) => {
  return API.post("/auth/login", data);
};